/* istanbul ignore file */

import { createBrowserHistory } from 'history';

import { CookieCategory } from '@shared-types/optanon.types';
import { IS_DEBUG } from '@utilities/browser';
import { appInsightsConnectionString, appInsightsSamplingPercentage } from '@utilities/WindowContext';

const initAppInsight = async () => {
  if (!appInsightsConnectionString || process.env.NODE_ENV === 'development') return;

  const { default: CookieConsentServiceInstance } = await import(
    /* webpackPrefetch: true */ '@services/CookieConsentService'
  );

  const browserHistory = createBrowserHistory();

  const { ReactPlugin } = await import(/* webpackPrefetch: true */ '@microsoft/applicationinsights-react-js');
  const reactPlugin = new ReactPlugin();

  const { ApplicationInsights } = await import(/* webpackPrefetch: true */ '@microsoft/applicationinsights-web');
  const appInsights = new ApplicationInsights({
    config: {
      samplingPercentage: appInsightsSamplingPercentage ?? 10,
      enableDebug: IS_DEBUG,
      isBeaconApiDisabled: false,
      enableAutoRouteTracking: true,
      extensions: [reactPlugin],
      extensionConfig: {
        [reactPlugin.identifier]: { history: browserHistory },
      },
      cookieCfg: {
        enabled: CookieConsentServiceInstance.getCookiesAccepted(CookieCategory.PERFORMANCE),
      },
      connectionString: appInsightsConnectionString,
    },
  });

  const core = appInsights.loadAppInsights();

  CookieConsentServiceInstance.waitForCookiesAccepted(CookieCategory.PERFORMANCE).then(() => {
    core.getCookieMgr().setEnabled(true);
  });
  appInsights.trackPageView();

  window.appInsights = core;
};

initAppInsight();
